import { purgeSession } from '@/utility/auth/purgeSession';
import { subscribeToAuthSessionBroadcast } from '@/utility/auth/sessionBroadcast';
import { store } from '@/redux/store';

let isInitialized = false;

/** Wire cross-tab session purge listeners once on the client. */
export const initAuthSessionSync = (): void => {
  if (typeof window === 'undefined' || isInitialized) {
    return;
  }

  isInitialized = true;

  subscribeToAuthSessionBroadcast(() => {
    void purgeSession({
      dispatch: store.dispatch,
      skipBroadcast: true,
    });
  });

  window.addEventListener('storage', (event) => {
    if (event.key !== 'persist:root') {
      return;
    }

    if (!event.newValue) {
      void purgeSession({
        dispatch: store.dispatch,
        skipBroadcast: true,
      });
      return;
    }

    try {
      const newState = JSON.parse(event.newValue);

      if (newState.auth) {
        store.dispatch({
          type: 'HYDRATE',
          payload: JSON.parse(newState.auth),
        });
      }
    } catch {
      // Ignore malformed persist payloads from other tabs.
    }
  });
};
